import { IValuesFilterInstallments } from "../DriveTypes";

export const valuesDefaultFilterInstallments: IValuesFilterInstallments = {
  startSignatureDate: "",
  endSignatureDate: "",

  proposalCode: "",
  installmentReceipt: "ALL",
};
